import { LanguageMenu } from './LanguageMenu';
import { ThemeToggle } from './ThemeToggle';
import { ORG_URL } from '../data/site';
import type { SiteLocale } from '../locales';

interface Props {
  readonly locale: SiteLocale;
  readonly onLocaleChange: (path: string) => void;
}

export function Header({ locale, onLocaleChange }: Props) {
  return (
    <header className="sticky top-0 z-40 border-b border-line bg-bg/85 backdrop-blur">
      <div className="wrap flex h-16 items-center gap-4">
        <a href="/" className="group flex shrink-0 items-center gap-2.5">
          <img src="/logo.svg" alt="" aria-hidden="true" width={28} height={28} className="rounded-lg" />
          <span className="text-[1.05rem] font-bold tracking-tight">DopeJs</span>
          <span className="mono-label rounded-full border border-line px-2 py-0.5 text-[0.62rem]">OSS</span>
        </a>

        <nav className="ms-auto flex items-center gap-1.5 text-sm" aria-label="Primary">
          {/* The in-page links point at sections of this same page, so they are
              dropped on narrow screens where the controls need the room. */}
          <a href="/#projects" className="hidden rounded-lg px-3 py-2 text-muted transition-colors hover:text-fg sm:inline-block">
            {locale.ui['nav.projects']}
          </a>
          <a href="/#about" className="hidden rounded-lg px-3 py-2 text-muted transition-colors hover:text-fg sm:inline-block">
            {locale.ui['nav.about']}
          </a>
          <LanguageMenu locale={locale} onChange={onLocaleChange} />
          <ThemeToggle label={locale.ui['nav.theme']} />
          <a
            href={ORG_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="chip px-2"
            aria-label={locale.ui['nav.github']}
            title={locale.ui['nav.github']}
          >
            <svg viewBox="0 0 16 16" width="15" height="15" fill="currentColor" aria-hidden="true">
              <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27s1.36.09 2 .27c1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8Z" />
            </svg>
          </a>
        </nav>
      </div>
    </header>
  );
}
